import ServiceCRUD from '../../../../services/ServiceCRUDSCALE';

class ScalesService extends ServiceCRUD {
  constructor() {
    super('api/report/agent');
  }
}

export default new ScalesService();
